export function getGroupAdminMembership(groupMemberships = []) {
  return (groupMemberships || []).find(
    (membership) => membership?.role_in_group === "group_admin"
  );
}

export function getGroupAdminDashboardPath(groupMemberships = []) {
  const groupAdmin = getGroupAdminMembership(groupMemberships);
  if (!groupAdmin) return null;
  return "/group-admin";
}

export function hasSellerMembership(groupMemberships = []) {
  return (groupMemberships || []).some(
    (membership) => membership?.role_in_group === "seller"
  );
}

export function getNavbarDashboardLink({ role, groupMemberships }) {
  const groupAdminPath = getGroupAdminDashboardPath(groupMemberships);
  if (groupAdminPath) return groupAdminPath;

  if (role === "admin" || role === "superadmin") return "/admin";
  if (role === "association_manager") return "/association";
  if (role === "seller" || hasSellerMembership(groupMemberships)) return "/seller";
  return null;
}

export function canAccessAdminDashboard({ role }) {
  return role === "admin" || role === "superadmin";
}

export function getPostAuthRedirect({ role, groupMemberships }) {
  return getNavbarDashboardLink({ role, groupMemberships }) || "/";
}
